export default __webpack_public_path__ + "static/media/delivery2.6f4326c6.jpg";